import {getApiConfig} from '../../config/api.config';
import {authenticatedFetch} from '../../features/auth/AuthenticatedService';

export interface ILookupIdentifier {
    authoringSystem: string;
    authoringSystemForeignKey: string
}



export  abstract class CommunicareBase{
    get domain() {
        return getApiConfig().url.medicationsManagement.replace(/\/+$/, "");
    }
    get baseUrl(){
        return 'api/v1';
    }
    
    createUrl(segments:string[]){
        return `${this.baseUrl}/${segments.map(x=>x.replace(/\/+$/, "")).join('/')}`;
    }
    async AsyncPost(path: string, data: any) {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        };

        let url = `${this.domain}/${path}`;

        let response = await authenticatedFetch(url, requestOptions);
        return await response.json();
    }

    async AsyncPut(path: string, data: any) {
        const requestOptions = {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        };

        let url = `${this.domain}/${path}`;

        let response = await authenticatedFetch(url, requestOptions);
        return await response.json();
    }

    async AsyncGet(path: string) {
        const requestOptions = {
            method: 'GET',
            headers: { 'Accept': 'application/json' },
        };
        let url = `${this.domain}${path}`;
        let response = await authenticatedFetch(url, requestOptions);
        if (response.status === 204) {
            return null;
        }
        return await response.json();
    }
}
